import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Icon,
  Modal,
  Radio,
  Tab,
  Form,
  Divider,
} from 'semantic-ui-react';
import { Formik } from 'formik';

import { updateOutcome, getDomains } from '../../../../store/actions';

import {
  convertFromBackendFormat,
  convertToBackendFormat,
  initialValues,
  outcomeValidation,
} from '../../../../validations/addOutcomeValidation';

import MultiLanguageInput from '../../../../components/form/inputs/multiLanguageInput';
import MultiLanguageTextArea from '../../../../components/form/inputs/multiLanguageTextArea';
import { SUPPORTED_LANGUAGES } from '../../../../i18n';

export default class EditModalOutcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        title: '',
        description: '',
        isEnable: '',
      },
    };
  }

  componentDidMount() {
    const { getDomains } = this.props;
    getDomains();
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  editSelected(item) {
    const convertedForm = convertFromBackendFormat(item);
    this.setState({
      form: convertedForm,
    });
  }

  render() {
    const { modal } = this.state;
    const { item, t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelected(item)}
          >
            <Icon name="edit" />
            {t('actions.edit')}
          </label>
        }
        className="edit-outcome"
      >
        <Modal.Header>{t('specific_actions.edit_outcome')}</Modal.Header>
        <Modal.Content>
          <EditOutcomeForm
            item={item}
            {...this.props}
            isNew={false}
            toggle={() => this.toggle()}
            form={this.state.form}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

class EditOutcomeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      currentLanguage: 'en',
    };
  }

  async handleValidSubmit(values) {
    try {
      const { form, updateOutcome, toggle } = this.props;
      const { status } = this.state;
      const legacyData = convertToBackendFormat(values);
      legacyData.isEnable = status;

      await updateOutcome(form.id, form.policyId, legacyData);
      toggle();
    } catch (error) {
      console.error('Error: EditOutcomeForm ~ handleValidSubmit', error);
    }
  }

  toggleCheckbox() {
    this.setState((prevState) => {
      return { status: !prevState.status };
    });
  }

  componentWillMount() {
    const { form } = this.props;
    this.setState({ status: Boolean(form.isEnable) });
  }

  // Get reference values for translation
  getReferenceValue = (fieldName, values) => {
    if (this.state.currentLanguage === 'en') return '';
    return values[fieldName]?.en || '';
  };

  render() {
    const { toggle, form, outcomeUpdateLoading, t } = this.props;
    const { status, currentLanguage } = this.state;

    return (
      <div className="multilingual-outcome-form">
        <Formik
          onSubmit={(values) => this.handleValidSubmit(values)}
          initialValues={initialValues(form, true)}
          validationSchema={outcomeValidation(t, true)}
          context={{ isMultiLang: true }}
        >
          {({ handleSubmit, values }) => {
            // Create language tabs
            const languageTabs = SUPPORTED_LANGUAGES.map(
              (lang) =>
                lang.menu && {
                  menuItem: {
                    key: lang.locale,
                    content: (
                      <span>
                        {lang.flag} {lang.name}
                        {lang.locale === 'en' && (
                          <span style={{ color: '#f39c12' }}> *</span>
                        )}
                      </span>
                    ),
                  },
                  render: () => (
                    <Tab.Pane key={lang.locale}>
                      <Form onSubmit={handleSubmit} className="venue-form">
                        <MultiLanguageInput
                          id="title"
                          name="title"
                          placeholder={t('formulary.placeholder.enter_title')}
                          labelText={t('common.title')}
                          requiredStar
                          currentLanguage={lang.locale}
                          referenceValue={this.getReferenceValue(
                            'title',
                            values
                          )}
                        />

                        <MultiLanguageTextArea
                          id="description"
                          name="description"
                          placeholder={t(
                            'formulary.placeholder.enter_description'
                          )}
                          labelText={t('common.description')}
                          requiredStar
                          currentLanguage={lang.locale}
                          referenceValue={this.getReferenceValue(
                            'description',
                            values
                          )}
                        />

                        {lang.locale === 'en' && (
                          <div className="edit-outcome-status-bar">
                            <label>
                              {t('admin.activity_settings.outcomes.enable')}
                            </label>
                            <div className="two-step-radio-container-admin status-right">
                              <Radio
                                name="isEnable"
                                toggle
                                className="modal-toggle"
                                checked={status}
                                onChange={() => this.toggleCheckbox()}
                              />
                            </div>
                          </div>
                        )}

                        <div className="model-buttons">
                          <Button
                            className="Secondary-Button"
                            type="button"
                            onClick={() => toggle()}
                          >
                            {t('actions.cancel')}
                          </Button>
                          <Button
                            content={t('actions.save')}
                            type="submit"
                            className="Primary-Button"
                            loading={outcomeUpdateLoading}
                            disabled={outcomeUpdateLoading}
                          />
                        </div>
                      </Form>
                    </Tab.Pane>
                  ),
                }
            );

            return (
              <Tab
                panes={languageTabs}
                onTabChange={(e, { activeIndex }) => {
                  const selectedLang = SUPPORTED_LANGUAGES[activeIndex];
                  this.setState({ currentLanguage: selectedLang.locale });
                }}
              />
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    outcomes: state.extra.outcomes,
    outcomeUpdateLoading: state.admin.outcomeUpdateLoading,
    domains: state.admin.domains,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateOutcome,
      getDomains,
    },
    dispatch
  );
};

EditModalOutcome = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditModalOutcome);

EditModalOutcome = withTranslation()(EditModalOutcome);
EditOutcomeForm = withTranslation()(EditOutcomeForm);
